export const GET_USER_CARS_START = 'GET_USER_CARS_START';
export const GET_USER_CARS_SUCCESS = 'GET_USER_CARS_SUCCESS';
export const GET_USER_CARS_FAILURE = 'GET_USER_CARS_FAILURE';
